/**
 * Created by rcabr on 5/13/2016.
 */

angular.module('eStories.mobileSort', [

    /* The filters and sorting are a separate page in mobile, overlays are a no no for mobile,  This is done for
     better UX */

])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.mobileSort', {
                url: '/sort?source',
                views: {
                    'filter@': {
                        controller: 'SortCtrl as sortCtrl',
                        templateUrl: 'store/mobileSortFilters/sorting/mobileSorting.tmpl.html'
                    }
                }
            });
    }]);

